import Vue from 'vue'

const commonFn = {
  // 解决IOS软键盘收回页面出现空白的情况
  getKeyboard() {
    // IOS
    document.body.addEventListener('focusin', () => {
      // 软键盘弹出的事件处理
    })
    document.body.addEventListener('focusout', () => {
      // 软键盘收起的事件处理
      var currentPosition, timer
      var speed = 1// 页面滚动距离
      timer = setInterval(function() {
        currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        currentPosition -= speed
        window.scrollTo(0, currentPosition)// 页面向上滚动
        currentPosition += speed // speed变量
        window.scrollTo(0, currentPosition)// 页面向下滚动
        clearInterval(timer)
      }, 1)
    })
  },
  j2s(obj) {
    return JSON.stringify(obj)
  },

  toastMsg(msg, type, pos) {
    var position = pos || 'middle'
    switch (type) {
      case 'normal':
        window.bus.$vux.toast.text(msg, position)
        break
      case 'success':
        window.bus.$vux.toast.show({
          text: msg,
          type: 'success',
          position: position
        })
        break
      case 'warning':
        window.bus.$vux.toast.show({
          text: msg,
          type: 'warn',
          position: position
        })
        break
      case 'error':
        window.bus.$vux.toast.show({
          text: msg,
          type: 'cancel',
          position: position
        })
        break
      default:
        window.bus.$vux.toast.text(msg, position)
        break
    }
  },
  cloneJson(obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  closeGlobalLoading() {
    window.bus.$vux.loading.show({
      text: 'Loading'
    })
  },
  openGlobalLoading() {
    window.bus.$vux.loading.hide()
  },
  // 删除左右两端的空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '')
  },

  checkEmpty: function(v) {
    return !!v.trim()
  },
  checkReg(v, reg) {
    return reg.test(v)
  },

  // 日期补0
  formatDateNum: function(value) {
    if (parseInt(value) < 10) {
      return '0' + parseInt(value)
    } else {
      return parseInt(value) + ''
    }
  },
  sessionSet(name, obj) {
    return sessionStorage.setItem(name, JSON.stringify(obj))
  },
  sessionGet(name) {
    return JSON.parse(sessionStorage.getItem(name))
  },
  wxSetTitle(title) {
    if (title === undefined || window.document.title === title) {
      return
    }
    document.title = title
    var mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
      var iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.setAttribute('src', '')
      var iframeCallback = function() {
        setTimeout(function() {
          document.body.removeChild(iframe)
        }, 5000)
      }
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    }
  },

  /**
     * 判断用户是否登录
     */
  isLogin() {
    return new Promise((resolve, reject) => {
      if (Vue.ls.get('WxUserOpenIDNew')) {
        resolve(false)
      } else {
        resolve(false)
      }
    })
  },

  /**
    * 去掉历史记录重复数据
    */
  unique(arr) {
    var result = []
    var isRepeated
    var i
    for (i = 0; i < arr.length; i++) {
      isRepeated = false
      for (var j = i + 1; j < arr.length; j++) {
        if (arr[i] == arr[j]) {
          isRepeated = true
          break
        }
      }
      if (!isRepeated) {
        result.push(arr[i])
      }
    }
    return result
  },
  // 强制保留2位小数，如：2，会在2后面补上00.即2.00
  toDecimal2(x) {
    var f = parseFloat(x)
    if (f == 0) {
      return f
    }
    if (isNaN(f)) {
      return 0
    }
    var newF = Math.round(x * 100) / 100
    if (newF == 0) {
      return newF
    }
    var s = newF.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    return s
  },
  getRem(rem) {
    return rem / 36 + 'rem'
  },
  stripscript(s) {
    var pattern = new RegExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？]')
    var rs = ''
    for (var i = 0; i < s.length; i++) {
      rs = rs + s.substr(i, 1).replace(pattern, '')
    }
    return rs
  },
  initTypeShow(areaData, list) {
    var i = 0
    if (areaData.length == 1 && areaData[0].areaCode == '6') {
      for (i = 0; i < list.length; i++) {
        if (list[i].busType != '01') {
          list.splice(i, 1)
          i--
        }
      }
    }
    if (areaData.length == 1 && areaData[0].areaCode == '10') {
      for (i = 0; i < list.length; i++) {
        if (list[i].busType != '02') {
          list.splice(i, 1)
          i--
        }
      }
    }
    if (areaData.length == 2 && areaData[0].areaCode == '67' && areaData[1].areaCode == '10') {
      for (i = 0; i < list.length; i++) {
        if (list[i].busType != '02' && list[i].busType != '01') {
          list.splice(i, 1)
          i--
        }
      }
    }
    console.log(list)
    return list
  },
  initAreaShow(typeList, list) {
    var i = 0
    var type02 = false
    var type01 = false
    if (typeList.length > 0) {
      // 地区：央企招投标 （67） => 工程建设（01）
      for (i = 0; i < typeList.length; i++) {
        if (typeList[i].busType == '01') {
          type01 = true
        }
      }
      if (!type01) {
        for (i = 0; i < list.length; i++) {
          if (list[i].areaCode == '67') {
            list.splice(i, 1)
            i--
          }
        }
      }
      // 地区：中央政采 （10） => 工程建设（02）
      for (i = 0; i < typeList.length; i++) {
        if (typeList[i].busType == '02') {
          type02 = true
        }
      }
      if (!type02) {
        for (i = 0; i < list.length; i++) {
          if (list[i].areaCode == '10') {
            list.splice(i, 1)
            i--
          }
        }
      }
    }
    return list
  }
}
export default commonFn
export const toastMsg = (msg, type) => {
  const position = 'middle'
  Vue.prototype.$vux.toast.time = 1000
  switch (type) {
    case 'normal':
      Vue.prototype.$vux.toast.text(msg, position)
      break
    case 'success':
      Vue.prototype.$vux.toast.show({
        text: msg,
        type: 'success',
        position: position
      })
      break
    case 'warning':
      Vue.prototype.$vux.toast.show({
        text: msg,
        type: 'warn',
        position: position
      })
      break
    case 'error':
      Vue.prototype.$vux.toast.show({
        text: msg,
        type: 'cancel',
        position: position
      })
      break
    default:
      Vue.prototype.$vux.toast.text(msg, position)
      break
  }
}

/**
    * 去掉历史记录重复数据
    */
export function unique(arr) {
  var result = []
  var isRepeated
  var i
  for (i = 0; i < arr.length; i++) {
    isRepeated = false
    for (var j = i + 1; j < arr.length; j++) {
      if (arr[i] === arr[j]) {
        isRepeated = true
        break
      }
    }
    if (!isRepeated) {
      result.push(arr[i])
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/global.js